import { Box, Skeleton } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import useScreenWidth from '../../hooks/useScreenWidth'

function HomeCalendarSkeleton() {
  const isMobile = useScreenWidth(960)

  return (
    <Grid container spacing={2} style={isMobile ? { paddingTop: 0 } : { padding: 16 }}>
      <Grid xs={12} style={isMobile ? { paddingTop: 0 } : { padding: 16 }}>
        <Box>
          <Skeleton variant="rectangular" animation="wave" height={694} width="100%" sx={{ borderRadius: 8 }} />
        </Box>
      </Grid>
    </Grid>
  )
}

export default HomeCalendarSkeleton
